'use strict';

/**
* @ngdoc service
* @name tcApp:ElementStateService
* @description
* Service that stores the state of elements in Angular cache
* Element state is keyed with the route parameters
*/
angular.module('tcApp')
.service('ElementStateService', function($cacheFactory, $rootScope, $route, $log) {
	var ElementStateService = this;
	var elementStateCache = $cacheFactory('elementState');
	// Second cache for elements to be preserved across routes
	var elementStatePersistantCache = $cacheFactory('elementStatePersistant');
	
	// Sets the element state for a particular key
	// routeKey is optional for calls from route events
	this.set = function(key, state, routeKey) {
		if (angular.isUndefined(key)) return;
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			var elementData = elementStateCache.get(routeKey);
			if (!angular.isObject(elementData)) {
				elementData = {};
			}
			elementData[key] = state;
			elementStateCache.put(routeKey, elementData);
		} catch (err) {
			// Catch any error because element state is not critical
			$log.error('ElementStateService.set: ' + err);
		}
	};
	
	// Removes element state data for a particular key
	// called when element value changes to be unefined
	this.removeKey = function(key, routeKey) {
		if (angular.isUndefined(key)) return;
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			var elementData = elementStateCache.get(routeKey);
			if (!angular.isObject(elementData)) {
				elementData = {};
			}
			elementData[key] = undefined;
		} catch (err) {
			// Catch any error because element state is not critical
			$log.error('ElementStateService.removeKey: ' + err);
		}	
	};
	
	// Gets element state, with an optional key
	// routeKey is optional for calls from route events
	this.get = function(key, routeKey) {
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			var elementData = elementStateCache.get(routeKey);
			
			if (angular.isObject(elementData)) {
				if ((angular.isDefined(key)) && (key !== '')) {
					elementData = elementData[key];
				}
			}
		} catch (err) {
			$log.error('ElementStateService.get: ' + err);
		}
		return elementData;
	};
	
	// Removes all element state for a routeKey
	this.remove = function(routeKey) {
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			elementStateCache.remove(routeKey);
		} catch (err) {
			$log.error('ElementStateService.remove: ' + err);
		}
	};
	
	// Removes all element state for a specified component on a route
	this.removeKeysForComponent = function(componentHtmlName, routeKey) {
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			var elementData = elementStateCache.get(routeKey);
			if (!angular.isObject(elementData)) return;
			
			angular.forEach(elementData, function(element, elementKey, elementObject) {
				if (elementKey.indexOf(componentHtmlName + '-') !== 0) return;
				elementObject[elementKey] = undefined;
			});
		} catch (err) {
			$log.error('ElementStateService.removeKeysForComponent: ' + err);
		}
	};
	
	// Removes all element state on a route that contains partKey 
	// eg: for $scope.componentHtmlName-rowGroup-
	// call: ElementStateService.removeKeysContaining('-rowGroup-', routeKey);
	this.removeKeysContaining = function(partKey, routeKey) {
		try {
			routeKey = (routeKey ? routeKey : angular.toJson($route.current.params));
			var elementData = elementStateCache.get(routeKey);
			if (!angular.isObject(elementData)) return;
			
			angular.forEach(elementData, function(element, elementKey, elementObject) {
				if (elementKey.indexOf(partKey) === -1) return;
				elementObject[elementKey] = undefined;
			});
		} catch (err) {
			$log.error('ElementStateService.removeKeysContaining: ' + err);
		}
	};
	
	// Clears element state
	this.removeAll = function() {
		elementStateCache.removeAll();
	};
	
	// Returns info for the element state cache
	this.info = function() {
		return elementStateCache.info();
	};
	
	// Sets element state that persists across routes
	// Must be manually cleared
	this.setPersistant = function(key, state) {
		if (angular.isUndefined(key)) return;
		try {
			elementStatePersistantCache.put(key, state);
		} catch (err) {
			// Catch any error because element state is not critical
			$log.error('ElementStateService.setPersistant: ' + err);
		}
	};
	
	// Gets element state that persists across routes
	this.getPersistant = function(key) {
		if (angular.isUndefined(key)) return;
		try {
			var state = elementStatePersistantCache.get(key);
		} catch (err) {
			// Catch any error because element state is not critical
			$log.error('ElementStateService.getPersistant: ' + err);
		}
		return state;
	};
	
	// Clears elementStatePersistantCache
	this.removeAllPersistant = function() {
		elementStatePersistantCache.removeAll();
	};
	
	// Returns info for elementStatePersistantCache
	this.infoPersistant = function() {
		return elementStatePersistantCache.info();
	};
	
	$rootScope.$on('tcMenu:MainMenuSelected', function() { //eslint-disable-line angular/on-watch
		ElementStateService.removeAll();
	});
});
